import React, { Component } from 'react';
import IosSwitch from '../IosSwitch';
import DefaultButton from '../DefaultButton';
import DefaultLoader from '../DefaultLoader';
import ReportHelper from '../../helper/ReportHelper';
import moment from 'moment';
import Firestore from '../../api/firebase/Firestore';
import PaymentMethodHelper from '../../helper/PaymentMethodHelper';
import { toast } from 'react-toastify';
import { FormLabel } from '@material-ui/core';
import ReportDefaultModalOptions from './ReportDefaultModalOptions';

export default class TournamentEnrollReport extends Component {

    state = {
        loadingModal: true,
        tournamentDocs: [],
        tournamentDoc: null,
        tournament: null,
        paymentMethods: [],
        start: moment().startOf('month').startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
        output: 'download',
        format: 'pdf',
    }

    async componentDidMount() {

        if (this.props.getDocs && this.props.getDocs) {

            for (let index = 0; index < this.props.getDocs.length; index++) {
                
                const getDoc = this.props.getDocs[index];
                await getDoc(this);
            }
        }

        this.setState({ loadingModal: false });
    }

    async getReportDocs() {

        let docs = [];

        let tournament = this.state.tournamentDoc;

        for (let category of tournament.category) {
            
            if (category.print) {

                for (let categoryClass of category.classes) {
                
                    if (categoryClass.print) {

                        for (let subscription of categoryClass.participants) {

                            let date = moment(subscription.date.toDate()).startOf('day');

                            if (!this.state.start || moment(date).isSameOrAfter(moment(this.state.start).startOf('day'))) {

                                if (!this.state.end || moment(date).isSameOrBefore(moment(this.state.end).startOf('day'))) {

                                    let players = await Firestore.customQuery('user').where(Firestore.idField(), 'in', subscription.players).get();

                                    let orderQuery = await Firestore.getDoc('order', subscription.id_order);
                                    let order = orderQuery.data();

                                    if (!this.state.paymentMethods.length || (order && this.state.paymentMethods.includes(order.payment_method))) {
                                    
                                        let playersDisplay = [];
                                        players.forEach((doc, key) => { playersDisplay.push(doc.data().name) });
                                        playersDisplay = playersDisplay.join(', ');

                                        docs.push({
                                            name: playersDisplay,
                                            category: `Categoria ${category.title} - ${categoryClass.title}`,
                                            payment_method: `${order ? PaymentMethodHelper.getPaymentMethodLabel(order.payment_method) : 'Não encontrado'}`,
                                            order: `${order ? order.title : 'Pedido não encontrado'}`,
                                            date: `${date.format('DD/MM/YYYY HH:mm')}`,
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return docs;
    }

    async print() {

        if (this.state.tournamentDoc) {

            this.setState({ loadingModal: true });

            let name = `Inscrições - ${this.state.tournamentDoc.name}`;
            let subtitle = `De ${moment(this.state.start).format('DD/MM/YYYY')} até ${moment(this.state.end).format('DD/MM/YYYY')}`;
            let docs = await this.getReportDocs();
            let report = await ReportHelper.createReport(name, 6, subtitle);

            report = await ReportHelper.createColumns(report, docs, [
                { name: 'Nome', width: 13, getText: (doc) => doc.name ? ReportHelper.treatName(doc.name) : '' },
                { name: 'Categoria', width: 50, getText: (doc) => doc.category },
                { name: 'Pagamento', width: 110, getText: (doc) => doc.payment_method },
                { name: 'Pedido', width: 140, getText: (doc) => doc.order },
                { name: 'Data', width: 169, getText: (doc) => doc.date },
            ]);

            ReportHelper.print(report, this.state.output, this.state.format);

            this.setState({ loadingModal: false });

        } else {

            toast.warn('Selecione um torneio para imprimir');
        }
    }

    renderLoading() {

        return (

            <div style={{ height: 200 }}>
                <DefaultLoader/>
            </div>
        )
    }

    handleTournamentChange(value) {

        let doc = this.state.tournamentDocs.find(item => item.id === value);
        this.setState({ tournamentDoc: doc, start: doc.start.toDate(), end: doc.end.toDate() });
    }

    renderModal() {

        return (
            <div>
                { ReportHelper.renderTournamentSelection(this, this.state.tournamentDocs, 'tournament', (value) => { this.handleTournamentChange(value) }) }

                { this.state.tournamentDoc ? <FormLabel style={{ paddingBottom: 18 }} component="legend">Selecione as Classes</FormLabel> : null }
                {
                    this.state.tournamentDoc ?

                        this.state.tournamentDoc.category.map((category, key) => {

                            if (category.checked) {

                                return (

                                    <div>
                                        <IosSwitch fullWidth label={category.title} checked={category.print} onChange={(e) => { let tournament = this.state.tournamentDoc; tournament.category[key].print = e; this.setState({ tournamentDoc: tournament }) }} />
                                        
                                        {
                                            this.state.tournamentDoc.category[key].print ? 

                                                this.state.tournamentDoc.category[key].classes.map((categoryClass, classKey) => {
                                                    
                                                    if (categoryClass.checked) {

                                                        return (
                                                            <div style={{ marginLeft: 20 }}>
                                                                <IosSwitch fullWidth label={categoryClass.title} checked={categoryClass.print} onChange={(e) => { let tournament = this.state.tournamentDoc; tournament.category[key].classes[classKey].print = e; this.setState({ tournamentDoc: tournament }) }} />
                                                            </div>
                                                        )
                                                    }
                                                })

                                            : null
                                        }
                                        
                                    </div>
                                )
                            }
                        })

                    : null
                }

                { ReportHelper.renderPaymentMethodSelection(this, 'paymentMethods', 'tournament') }
                { ReportHelper.renderPeriodSelection(this, 'start', 'end') }

                <ReportDefaultModalOptions onOutputChange={(value) => { this.setState({ output: value }) }} onFormatChange={(value) => { this.setState({ output: value }) }}/>
                <div style={{alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 50}}>
                    <DefaultButton width={'100%'} title={'Imprimir'} onClick={() => { this.print() }} />
                </div>
            </div>
        )
    }

    render() {

        return (

            this.state.loadingModal ? this.renderLoading() : this.renderModal()
        )
    }
}